import { Component, Input, OnInit } from "@angular/core";
import {
  NgbModal,
  ModalDismissReasons,
  NgbActiveModal,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { IParametrosBackEnd } from "../../interfaces/IParametrosBackEnd";
import { AuthService } from "../../services/auth.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-modal-login",
  templateUrl: "./modal-login.component.html",
  styleUrls: ["./modal-login.component.css"],
})
export class ModalLoginComponent implements OnInit {
  @Input() parametros: IParametrosBackEnd;
  @Input() empresaId: string;

  step: string;

  formdata;
  Nome: UntypedFormControl;
  Telefone: UntypedFormControl;
  Password: UntypedFormControl;
  Email: UntypedFormControl;
  TermosDeUso: UntypedFormControl;
  Empresa: UntypedFormControl;
  Codigo: UntypedFormControl;
  curriculo;
  showUsuarioCadastrado: boolean = false;
  criandoConta: boolean = false;
  isError: boolean = false;
  errorMessage: string = "";
  siteUrl: string = "";

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.initFacebook();
    this.step = "cadastro";
    this.siteUrl = environment.serverUrl;
  }

  ngOnInit() {
    //console.log(this.parametros);
    //console.log(this.empresaId);
    this.initForm();
  }

  initForm() {
    this.Email = new UntypedFormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern("[^ @]*@[^ @]*"),
      ])
    );
    this.Password = new UntypedFormControl(
      "",
      Validators.compose([Validators.required, Validators.minLength(6)])
    );

    this.Nome = new UntypedFormControl(
      "",
      Validators.compose([Validators.required, Validators.minLength(4)])
    );

    this.Telefone = new UntypedFormControl(
      "",
      Validators.compose([Validators.required])
    );

    this.TermosDeUso = new UntypedFormControl(
      true,
      Validators.compose([Validators.requiredTrue])
    );

    this.Codigo = new UntypedFormControl(
      "",
      Validators.compose([Validators.required])
    );

    this.formdata = new UntypedFormGroup({
      Nome: this.Nome,
      Telefone: this.Telefone,
      Password: this.Password,
      Email: this.Email,
      TermosDeUso: this.TermosDeUso,
    });
  }

  criarConta(user) {
    this.showUsuarioCadastrado = false;
    this.isError = false;
    this.errorMessage = "";
    if (user.valid) {
      let dataLogin = {
        userName: user.value.Email,
        password: user.value.Password,
      };
      this.criandoConta = true;
      this.authService.criarConta(user.value).subscribe(
        (ok) => {
          this.authService.login(dataLogin, this.parametros).subscribe(
            (redirect) => {
              if (this.curriculo) {
                this.authService.uploadCVCadastro(this.curriculo).subscribe(
                  (ok) => {
                    window.location.href = redirect;
                  },
                  (error) => {
                    this.criandoConta = false;
                    window.location.href = redirect;
                  }
                );
              } else {
                window.location.href = redirect;
              }
            },
            (error) => {
              this.criandoConta = false;
              this.isError = true;
              this.errorMessage =
                "Não foi possível criar sua conta. Se você já possui um cadastro, clique em RETORNAR PARA O LOGIN para continuar.";
            }
          );
        },
        (error) => {
          this.showUsuarioCadastrado = true;
          this.criandoConta = false;
          this.isError = true;
          this.errorMessage =
            "Erro ao criar conta. Verifique seus dados ou tente novamente.";
        }
      );
    }
  }

  login() {
    this.activeModal.dismiss("Close");
    const modalRef = this.modalService.open(ModalLoginComponent);
    modalRef.componentInstance.parametros = this.parametros;
  }

  loginFacebook() {
    console.log("MLF: ", this.parametros);
    this.authService.loginFacebook(this.parametros);
  }

  onFileChange(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.curriculo = event.target.files[0];
    }
  }

  salvarParametros() {
    console.log("params-linkedin: ", this.parametros);
    localStorage.setItem(
      "parametros-vaga-login-linkedin",
      JSON.stringify(this.parametros)
    );
  }

  abrirFormularioCadastro() {
    this.step = "cadastro";
  }

  abrirFormularioLogin() {
    this.step = "login";
  }
}
